import colors from "common/styles/colors";

export const snackbarStyles = theme => ({
    success: { backgroundColor: colors.success },
    error: { backgroundColor: colors.danger },
    warning: { backgroundColor: colors.warning },
    info: { backgroundColor: '#00d3ee' },
});